"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeCoveredBy = exports.PaymentMethodType = exports.DonationProvider = void 0;
var DonationProvider;
(function (DonationProvider) {
    DonationProvider["Stripe"] = "Stripe";
    DonationProvider["NFG"] = "NFG";
    DonationProvider["GlobalGiving"] = "GlobalGiving";
    DonationProvider["Betterplace"] = "Betterplace";
    DonationProvider["GiveIndia"] = "GiveIndia";
    DonationProvider["PayPal"] = "PayPal";
    DonationProvider["CAF"] = "CAF";
    DonationProvider["External"] = "External";
    DonationProvider["DCGF"] = "DCGF";
    DonationProvider["Give2Asia"] = "Give2Asia";
})(DonationProvider || (exports.DonationProvider = DonationProvider = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Card"] = "Card";
    PaymentMethodType["Payroll"] = "Payroll";
    PaymentMethodType["DeedCredit"] = "DeedCredit";
    PaymentMethodType["PayPal"] = "PayPal";
    PaymentMethodType["External"] = "External";
    PaymentMethodType["CorporateBudget"] = "CorporateBudget";
    /**
     * @deprecated Does not exist in
     * https://github.com/joindeed/marketplace/blob/700e7e19291122915fba1cf05765843752e0925f/packages/mongoose-models/src/enums/paymentMethodTypes.ts
     */
    PaymentMethodType["CorporateDonation"] = "CorporateDonation";
})(PaymentMethodType || (exports.PaymentMethodType = PaymentMethodType = {}));
var FeeCoveredBy;
(function (FeeCoveredBy) {
    FeeCoveredBy["Deed"] = "Deed";
    FeeCoveredBy["Company"] = "Company";
    FeeCoveredBy["User"] = "User";
})(FeeCoveredBy || (exports.FeeCoveredBy = FeeCoveredBy = {}));
//# sourceMappingURL=enums.js.map